import { Service } from 'typedi';
import { BaseService, IBaseService, SearchRequest, ServerResponse } from '../../../core/services/BaseService';
import { Appl } from '../../../core/Appl';
import { SpcModel } from './spcTest/SpcModel';

export interface ISpcService extends IBaseService {
  getUrl(model: SpcModel): Promise<ServerResponse>;
  getQueueAsFileAsync(format: string | undefined, searchModel: SearchRequest | undefined): Promise<ServerResponse>;
  getFinalEstimateAsync(spcTypeSubId: number): Promise<ServerResponse>;
}

@Service() // eslint-disable-next-line
export class SpcService extends BaseService implements ISpcService {
  constructor() {
    super(`${Appl.Setting.Services.PurchaseCalculatorServiceUrl}`);
  }

  public async getUrl(model: SpcModel): Promise<ServerResponse> {
    try {
      const response = await this.client.post(`/spc/purchase-calculator/member-url`, model);
      return this.getResponse(response);
    } catch (error: unknown) {
      return await this.getErrorResponse(error);
    }
  }
  
   public async getQueueAsFileAsync(format: string | undefined, searchModel: SearchRequest | undefined): Promise<ServerResponse> {
        try {
            const response = await this.client.post(`/spc/SpcSubmission/download-spc-purchase-estimate-queue/${format}`, searchModel, { responseType: 'blob' });
            return this.getResponse(response);
        } catch (error: unknown) {
            return await this.getErrorResponse(error);
        }
  }

    public async getFinalEstimateAsync(spcTypeSubId: number): Promise<ServerResponse> {
    try {
      const response = await this.client.get(`/spc/purchase-calculator/get-final-estimate/${spcTypeSubId}/true`);
      return this.getResponse(response);
    } catch (error: unknown) {
      return await this.getErrorResponse(error);
    }
  }

}
